const trackViewItem = () => {
  const productHandle = document
    .querySelector('.js-product')
    ?.getAttribute('data-product');

  // Trigger Facebook Pixel tracking for the product page
  if (window.fbq) {
    window.fbq('trackCustom', 'ViewItem', { product: productHandle });
  }
};

document.addEventListener('DOMContentLoaded', trackViewItem);
// The colourway swap shows a different product without a page load
document.addEventListener('product:swap', trackViewItem);
